import React, { useState, useEffect } from "react";
import { TextField } from "@mui/material";
import styles from "./login.module.css";
import { useLocation, useNavigate } from "react-router";
import {
  CognitoIdentityProviderClient,
  InitiateAuthCommand,
  RespondToAuthChallengeCommand,
} from "@aws-sdk/client-cognito-identity-provider";
import { jwtDecode } from "jwt-decode";
import companyStore from "../../Store/Store";

export default function Login() {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState(Array(6).fill(""));
  const [errorMessage, setErrorMessage] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [errorVerification, setErrorVerification] = useState("");
  const [otpVerified, setOtpVerified] = useState(false);
  const [session, setSession] = useState(null);
  const [resendClicked, setResendClicked] = useState(false);
  const [generatedUserName, setGeneratedUserName] = useState("");
  const navigate = useNavigate();
  const cognitoClient = new CognitoIdentityProviderClient({
    region: "ap-south-1",
  });
  const rawAuth = localStorage.getItem("authToken");
  const auth = rawAuth ? JSON.parse(rawAuth) : null;
  const location = useLocation();

  useEffect(() => {
    // Only navigate if auth is a valid, non-empty object
    if (
      auth &&
      typeof auth === "object" &&
      Object.keys(auth).length > 0 &&
      auth.AccessToken && // Ensure it’s a real auth token
      location.pathname !== "/content"
    ) {
      console.log("Navigating to /content");
      console.log("companyStore.Company_Id",companyStore.Company_Id);
      
      if (companyStore.Company_Id !== "") {
        navigate("/content");
      } else {
        navigate("/selectCompany");
      }
    } else {
      console.log("Navigation skipped: invalid auth or already on /content");
    }
  }, []);

  const sendOtp = async () => {
    if(email[0]!='6'&&email[0]!='7'&&email[0]!='8'&&email[0]!='9'){
      setErrorMessage("Phone number is a required field");
    }
    if (email === "") {
      setErrorMessage("Phone number is a required field");
      return;
    }
    let loginNumber=`+91${email}`
    console.log("verify validity");

    if (!isValidIndianPhoneNumber(loginNumber)) {
      console.log("invalid phonenumber");

      return;
    }

    try {
      const params = {
        AuthFlow: "CUSTOM_AUTH",
        ClientId: "77fglk6ill774c4v5toavua4md", // App client ID
        AuthParameters: { USERNAME: loginNumber },
      };

      const command = new InitiateAuthCommand(params);
      const authResponse = await cognitoClient.send(command);
      console.log("Auth Response:", authResponse);

      if (authResponse.ChallengeName === "CUSTOM_CHALLENGE") {
        setOtpSent(true);
        companyStore.setEmail(loginNumber);
        setSession(authResponse.Session);
        setGeneratedUserName(authResponse.ChallengeParameters.USERNAME);
        console.log("OTP has been sent to the user!");
        setStep(2);
        setErrorVerification("");
      }
    } catch (error) {
      console.log("Error during sending OTP:", error.name);
      setErrorMessage("This phone number is not registered");
      console.error("Error during sending OTP:", error);
    }
  };

  const reset = () => {
    setStep(1);
    setOtp(Array(6).fill(""));
  };

  function isValidIndianPhoneNumber(phone) {
    // Regex pattern for Indian phone numbers
    const indianPhoneRegex = /^\+91[ -]?(?:[6-9]\d{9})$/;

    if (indianPhoneRegex.test(phone)) {
      return true;
    } else {
      setErrorMessage("Please enter a valid phone number");
      return false;
    }
  }

  const verifyOtp = async () => {
    const otpString = otp.join("");
    if (otpString == "") {
      setErrorVerification("OTP is a required field");
      return;
    }
    if (otpString.length != 6) {
      setErrorVerification("Invalid OTP");
      return;
    }
    let loginNumber=`+91${email}`
    try {
      const params = {
        ChallengeName: "CUSTOM_CHALLENGE",
        ClientId: "77fglk6ill774c4v5toavua4md",
        ChallengeResponses: {
          USERNAME: loginNumber,
          ANSWER: otpString,
        },
        Session: session,
      };

      const command = new RespondToAuthChallengeCommand(params);
      const verifyResponse = await cognitoClient.send(command);
      console.log("Verify Response:", verifyResponse);

      if (verifyResponse.AuthenticationResult) {
        setOtpVerified(true);
        let Idtoken = verifyResponse.AuthenticationResult.IdToken;
        const authToken = {
          AccessToken: verifyResponse.AuthenticationResult.AccessToken,
          RefreshToken: verifyResponse.AuthenticationResult.RefreshToken,
          IdToken: verifyResponse.AuthenticationResult.IdToken,
        };
        let token = jwtDecode(Idtoken);
        console.log("token", token);

        // Check custom:cupi_admin and custom:cupi_owner
        const isAdmin =
          token["custom:cupi_admin"] && token["custom:cupi_admin"] !== "[]";
        const isOwner =
          token["custom:cupi_owner"] && token["custom:cupi_owner"] !== "[]";

        localStorage.setItem("authToken", JSON.stringify({}));

        // Allow access if either admin or owner role exists
        if (isAdmin || isOwner) {
          localStorage.setItem("authToken", JSON.stringify(authToken));
          console.log("User is authorized as:", isAdmin ? "Admin" : "Owner");
          // companyStore.setUserType("PineLabUser");
          console.log("OTP verified successfully!");
          navigate("/selectCompany");
        } else {
          console.log("UNAUTHORIZED.");
          setErrorVerification("You are not authorized to access the CUPI Dashboard.");
          // alert("UNAUTHORIZED.");

          return;
        }
      } else {
        setOtpVerified(false);
        setErrorVerification("Invalid OTP. Please try again.");
      }
    } catch (error) {
      resendOtp();
      setErrorVerification("The OTP is invalid. A new one has been sent.");
      console.error("Error during OTP verification:", error);
    }
  };

  const resendOtp = async () => {
    try {
      let loginNumber=`+91${email}`
      const params = {
        AuthFlow: "CUSTOM_AUTH",
        ClientId: "77fglk6ill774c4v5toavua4md", // App client ID
        AuthParameters: {
          USERNAME: loginNumber,
          PASSWORD: "YourHardcodedPassword", // Hardcoded password for step 1
        },
      };

      const command = new InitiateAuthCommand(params);
      const authResponse = await cognitoClient.send(command);
      console.log("Auth Response:", authResponse);

      if (authResponse.ChallengeName === "CUSTOM_CHALLENGE") {
        setOtpSent(true);
        companyStore.setEmail(loginNumber);
        setSession(authResponse.Session);
        setGeneratedUserName(authResponse.ChallengeParameters.USERNAME);
        console.log("OTP has been sent to the user!");
        setStep(2);
      }
    } catch (error) {
      console.log("Error during sending OTP:", error.name);
      setErrorMessage("This Phone number is not registered");
      console.error("Error during sending OTP:", error);
    }
  };

  const handleChange = (e, index) => {
    const value = e.target.value;

    if (/^\d?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (value && index < 5) {
        document.getElementById(`otp-input-${index + 1}`).focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      document.getElementById(`otp-input-${index - 1}`).focus();
    }
  };

  return (
    <div className={styles.logincontainer}>
      <div className={styles.card}>
        <div className={styles.finalCupiLogo}>
          <img className={styles.frameChild} alt="" src="/Final_Cupi.svg" />
        </div>
        <div className={styles.welcomeToEscrowStackParent}>
          {/* <div className={styles.welcomeToEscrow}>Welcome to Escrow Stack</div> */}
          <div className={styles.pleaseSignInTo}>
            Please sign-in to continue
          </div>
        </div>
        {step === 1 && (
          <div className={styles.inputoutlinedParent}>
            <TextField
              className={styles.inputoutlined}
              color="primary"
              value={email}
              Length={13}
              onChange={(event) => {
                setEmail(event.target.value);
                setErrorMessage("");
              }}
              inputProps={{ maxLength: 10 }}
              label="Enter Phone Number"
              size="medium"
              variant="outlined"
              type="email"
              sx={{
                "& .MuiInputBase-root": {
                  height: "58px",
                  borderRadius: "12px",
                },
              }}
            />
            {<div className={styles.error}>{errorMessage}</div>}
            <button
              className={styles.getOtp}
              onClick={() => {
                sendOtp();
              }}
            >
              <b className={styles.getOtp1}>Get OTP</b>
            </button>
          </div>
        )}
        {step === 2 && (
          <div className={styles.inputoutlinedParent}>
            <div className={styles.welcomeToEscrowotp}>Enter OTP</div>
            <div className={styles.otpInputs}>
              {otp.map((digit, index) => (
                <input
                  key={index}
                  id={`otp-input-${index}`}
                  type="text"
                  maxLength="1"
                  value={digit}
                  onChange={(e) => handleChange(e, index)}
                  onKeyDown={(e) => {
                    setErrorMessage("");
                    setErrorVerification("");
                    setResendClicked(false);
                    handleKeyDown(e, index);
                  }}
                  className={
                    errorVerification != ""
                      ? styles.invalidotpInput
                      : styles.otpInput
                  }
                />
              ))}
            </div>
            {resendClicked && (
              <div className={styles.resendOtp}>otp sent successfully</div>
            )}
            {errorVerification != "" && (
              <div className={styles.invalidotp}>{errorVerification}</div>
            )}
            <button
              className={styles.welcomeToEscrowotpbtn}
              onClick={() => {
                setResendClicked(true);
                setErrorVerification("");
                resendOtp();
              }}
            >
              Resend OTP
            </button>
            <button
              className={styles.getOtp}
              onClick={() => {
                verifyOtp();
              }}
            >
              <b className={styles.getOtp1}>Verify OTP</b>
            </button>

            <div className={styles.arrow}>
              <div
                className={styles.arrow1}
                onClick={() => {
                  setErrorVerification("");
                  setResendClicked(false);
                  reset();
                }}
              >
                <img
                  className={styles.frameChildarrow}
                  alt=""
                  src="/arrownarrowleft.svg"
                />
                <b className={styles.getOtp1arrow}>Back</b>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
